import 'babel-polyfill'
import './utils/momentLocales'
import { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router'

import { App, Index, NotFound } from './views'
import { initQueryParams } from './utils/init'

function InitializedApp() {
  const location = useLocation()
  const navigate = useNavigate()
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    const query = Object.fromEntries(new URLSearchParams(location.search))
    initQueryParams({ location: { query } }, path => navigate(path, { replace: true }), () => setInitialized(true))
  }, [])

  if (!initialized) return null
  return <App />
}

createRoot(document.getElementById('root')).render((
  <BrowserRouter>
    <Routes>
      <Route
        element={<InitializedApp />}
        path="/">
        <Route element={<Index />} index />
      </Route>
      <Route Component={NotFound} path="*" />
    </Routes>
  </BrowserRouter>
))
